import { Cliente } from '../types/Cliente';

export const clientesMock: Cliente[] = [
  {
    id: 1,
    razao: 'Empresa Alpha LTDA',
    cnpj: '12.345.678/0001-90',
    qtdTitulos: 50,
    valorTotal: 250000,
    pontualidade: 96,
    titulosAtrasados: 2
  },
  {
    id: 2,
    razao: 'Comércio Beta ME',
    cnpj: '98.765.432/0001-10',
    qtdTitulos: 30,
    valorTotal: 150000,
    pontualidade: 80,
    titulosAtrasados: 6
  },
  {
    id: 3,
    razao: 'Indústria Gama EIRELI',
    cnpj: '45.678.901/0001-23',
    qtdTitulos: 75,
    valorTotal: 500000,
    pontualidade: 92,
    titulosAtrasados: 4
  },
  {
    id: 4,
    razao: 'Distribuidora Delta SA',
    cnpj: '23.456.789/0001-45',
    qtdTitulos: 40,
    valorTotal: 300000,
    pontualidade: 85,
    titulosAtrasados: 5
  },
  {
    id: 5,
    razao: 'Serviços Épsilon LTDA',
    cnpj: '67.890.123/0001-56',
    qtdTitulos: 20,
    valorTotal: 100000,
    pontualidade: 75,
    titulosAtrasados: 8
  },
  {
    id: 6,
    razao: 'Comércio Zeta LTDA',
    cnpj: '11.222.333/0001-44',
    qtdTitulos: 15,
    valorTotal: 50000,
    pontualidade: 45,
    titulosAtrasados: 12
  },
  {
    id: 7,
    razao: 'Serviços Ômega ME',
    cnpj: '44.555.666/0001-77',
    qtdTitulos: 25,
    valorTotal: 80000,
    pontualidade: 55,
    titulosAtrasados: 10
  }
];
